export default __webpack_public_path__ + "static/media/O-031.a6a455cf.png";